import { Button, Input, Space, Tag, App } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SearchOutlined } from '@ant-design/icons';
import cl from './search.module.css';
import { useHttp } from '../../Hooks/Http.hook';

const Search = () => {
    const [value, setValue] = useState('');
    const [show, setShow] = useState(false);
    const [tags, setTags] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const navigate = useNavigate();
    const [search] = useSearchParams();
    const { request, loading } = useHttp(false);
    const { notification } = App.useApp();
    const city = useSelector((state) => state.city).items ?? {};
    const [defaultCity, setDefaultCity] = useState(null);
    useEffect(() => {
        const getCity = () => {
            request('/api/dict/city', 'GET')
                .then((res) => {
                    if (!res?.error) {
                        const cityInfo = {
                            city: res?.data[0].id,
                            cityName: res?.data[0].name,
                        };

                        setDefaultCity(cityInfo);
                    } else {
                        notification.warning({
                            message: 'Не удалось загрузить список городов',
                        });
                    }
                })
                .catch(() =>
                    notification.warning({
                        message: 'Не удалось загрузить список городов',
                    })
                );
        };
        setTags([
            'Газобетонные блоки',
            'Клей для газобетона',
            'Сайдинг',
            'Утеплитель',
        ]);
        if (search.get('search')) {
            setValue(search.get('search') ?? '');
        }
        if (!city) {
            getCity();
        }
    }, [search]);

    const changeHandler = async (val) => {
        setValue(val);
        if (val) {
            const res = await request(
                `/api/suggest/${(city ?? defaultCity)?.city}?search=${val}`,
                'GET'
            );
            const result = [];
            if (res.data) {
                res.data.forEach((item) => {
                    result.push(item.text);
                });
            }
            setSearchResult(result);
        }
    };
    return (
        <>
            {/* eslint-disable-next-line */}
            <div
                className={`${show ? cl.back : ''}`}
                onClick={(e) => {
                    if (e.target.getAttribute('data-main')) {
                        setShow(false);
                    }
                }}
                data-main="container"
            ></div>
            <div className={`${cl.searchContainer} ${show ? cl.show : ''}`}>
                <Input.Search
                    allowClear
                    placeholder="Что ищете?"
                    value={value}
                    className={`${cl.search} serch-container`}
                    onFocus={() => setShow(true)}
                    onChange={(e) => changeHandler(e.target.value)}
                    enterButton={
                        <Button
                            disabled={!value || loading}
                            className="search-btn"
                            type="primary"
                        >
                            <SearchOutlined />
                        </Button>
                    }
                    onSearch={(_, __, info) => {
                        if (info.source === 'input') {
                            setShow(false);
                            navigate(`/search/?search=${value}`);
                        }
                    }}
                />
                <Space wrap={false} size={[0, 8]} className={cl.tagContainer}>
                    {tags.map((item) => (
                        <Tag
                            key={item}
                            onClick={() => {
                                setValue(item);
                                changeHandler(item);
                            }}
                            className={cl.tag}
                        >
                            {item}
                        </Tag>
                    ))}
                </Space>
                <Space direction="vertical" className={cl.tagContainer}>
                    {searchResult.map((item) => (
                        <Button
                            type="link"
                            key={item}
                            onClick={() => {
                                setShow(false);
                                navigate(`/search/?search=${item}`);
                            }}
                        >
                            {item}
                        </Button>
                    ))}
                </Space>
            </div>
        </>
    );
};

export default Search;
